import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { QRCodeSVG } from 'qrcode.react'
import { SvgRenderer } from '~common/components/svg-renderer'
import { Icon } from '~common/components/icon/icon'
import { ExpandableSection } from '../section-wrapper'
import type { SettingsModalLogic } from '../../logic'

interface TelegramSectionProps {
    logic: SettingsModalLogic
    expanded: boolean
    onToggle: () => void
    showTitleInSection?: boolean
}

export const TelegramSection: React.FC<TelegramSectionProps> = ({
    logic,
    expanded,
    onToggle,
    showTitleInSection = true,
}) => {
    const { t } = useTranslation('settings')
    return (
        <ExpandableSection
            title={t('sections.telegram.title')}
            description={t('sections.telegram.description')}
            expanded={expanded}
            onToggle={onToggle}
            icon={
                <SvgRenderer
                    src="/assets/logos/telegram.svg"
                    width={30}
                    height={30}
                />
            }
            showTitleInSection={showTitleInSection}
        >
            <TelegramContent>
                <DescriptionText>
                    {t('sections.telegram.content')}
                </DescriptionText>
                <QRCodeSVG
                    value={logic.getTelegramBotLink()}
                    size={256}
                    level="H"
                />
                <LinkText
                    as="a"
                    href={logic.getTelegramBotLink()}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {logic.getTelegramBotLink()}
                </LinkText>
            </TelegramContent>
        </ExpandableSection>
    )
}

const TelegramContent = styled.div`
    padding: ${({ theme }) => theme.spacing[4]} 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing[8]};
    margin-top: ${({ theme }) => theme.spacing[4]};
`

const DescriptionText = styled.span`
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: ${({ theme }) => theme.typography.fontSize.base};
`

const LinkText = styled(DescriptionText)`
    word-break: break-all;
    font-family: monospace;
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    color: ${({ theme }) => theme.colors.info};
`
